import React, {useState} from "react";
import {useQueryClient} from "react-query";
import { makeStyles } from "@material-ui/core/styles";
import { InputLabel, MenuItem, Chip, Menu, Fade } from "@material-ui/core";
import { AddOutlined } from "@material-ui/icons";
import useTripLegs from "../services/trips/useTripLegs";
import __ from "lodash";

const TripLegMultiSelect = (props) => {

  const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      maxWidth: 300,
    },
    chips: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    chip: {
      margin: 2,
    },
    chipWithNoLabel: {
      margin: 2,
      '& .MuiChip-labelSmall': {
        paddingRight: 0,
      }
    },
    noLabel: {
      marginTop: theme.spacing(3),
    },
    menuPaper: {
      maxHeight: 500
    }
  }));

  const {tripUuid, afterTripLegUuid, id, label, readOnly, disabled, onChange, value: values} = props;
  const [oldValues, setOldValues] = useState(values);
  const [valuesArray, setValuesArray] = useState(values || []);
  const [addLegEl, setAddLegEl] = React.useState(null);
  const showSelector = Boolean(addLegEl);

  if (values !== oldValues) {
    setValuesArray(values);
    setOldValues(values);
  }
  const classNames = [props.className];
  if (props.readOnly) {
    classNames.push('readOnly');
  }

  const className = classNames.join(" ");
  const classes = useStyles();

  const queryClient = useQueryClient();
  const tripLegs = useTripLegs({queryClient, extraKeys: [tripUuid], useCache: true});

  const filteredLegs = [];
  if (tripLegs && Array.isArray(tripLegs.data)) {
    const startIdx = __.findIndex(tripLegs.data, {tripLegUuid: afterTripLegUuid});
    tripLegs.data.forEach((leg, i) => {
      const usedIdx = __.findIndex(valuesArray, {tripLegUuid: leg.tripLegUuid});
      if (i > startIdx && usedIdx < 0) {
        filteredLegs.push(leg);
      }
    });
  }

  const handleAdd = (event) => {
    setAddLegEl(event.currentTarget);
  };

  const handleDelete = ({value, position}) => {
    const values = [...valuesArray];
    values.splice(position,1);
    setValuesArray(values);
    if (onChange) {
      onChange(values);
    }
  }

  const handleSelectLeg = (leg) => {
    const record = __.pick(leg,
      ['tripLegUuid', 'originAirportCode', 'departureAirportTimeZone', 'destinationAirportCode', 'scheduledDepartureTimeUTC', 'scheduledArrivalTimeUTC', 'airlineCode', 'flightNo', 'flightDate']);
    const values = [...valuesArray, record];
    setAddLegEl(null);
    setValuesArray(values);
    if (onChange) {
      onChange(values);
    }
  }

  const handleCloseSelector = () => {
    setAddLegEl(null);
  };

  if (filteredLegs < 1 && (!valuesArray || valuesArray.length < 1)) return null;
  return (
    <div className={className}>
      {label?
        <InputLabel shrink id={`${id}-label`} style={{position: "relative", marginBottom: 0}} >{label}</InputLabel>
        :<></>
      }
      <div className={classes.chips} style={{...props.chipsStyle}}>
        {valuesArray.map((record, i) => (
          <Chip
            key={i}
            label={`${record.originAirportCode}-${record.destinationAirportCode}`}
            className={classes.chip}
            style={{...props.chipStyle}}
            size={"small"}
            onDelete={readOnly||disabled?null:()=>handleDelete({record, position: i})}
          />
        ))}
        {readOnly||disabled||filteredLegs.length < 1?<></>:
        <Chip
          key={'add'}
          color="primary"
          icon={<AddOutlined/>}
          className={classes.chipWithNoLabel}
          style={{...props.chipStyle}}
          size={"small"}
          onClick={(e)=>handleAdd(e)}
        />}
        {readOnly||disabled?<></>:
        <Menu
          id="fade-menu"
          MenuListProps={{
            'aria-labelledby': 'fade-button',
          }}
          anchorEl={addLegEl}
          open={showSelector}
          onClose={handleCloseSelector}
          TransitionComponent={Fade}
        >
          {(filteredLegs||[]).map((leg) => (
            <MenuItem onClick={() => handleSelectLeg(leg)}>{`${leg.originAirportCode}-${leg.destinationAirportCode}`}</MenuItem>
          ))}
        </Menu>}
      </div>
    </div>
  );
}

export default TripLegMultiSelect;
